import React from 'react';
import { DndContext, closestCenter, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import SortableItem from './sortable-item.component';

interface ButtonsDndProps {
  fields: any[];
  move: (from: number, to: number) => void;
  renderButton: (item: any, index: number) => React.ReactNode;
}

const ButtonsDnd: React.FC<ButtonsDndProps> = ({ fields, move, renderButton }) => {
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 5
      }
    })
  );

  const handleDragEnd = (event: any) => {
    const { active, over } = event;
    if (!over) return;
    if (active.id !== over.id) {
      const oldIndex = fields.findIndex((item) => item.id === active.id);
      const newIndex = fields.findIndex((item) => item.id === over.id);
      move(oldIndex, newIndex);
    }
  };

  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
      <SortableContext items={fields.map((item) => item.id)} strategy={verticalListSortingStrategy}>
        {fields.map((item, index) => (
          <SortableItem key={item.id} id={item.id}>
            {renderButton(item, index)}
          </SortableItem>
        ))}
      </SortableContext>
    </DndContext>
  );
};

export default ButtonsDnd;
